import { h } from "preact";
import style from "./SocialButton.css";
import CloseButton from "../CloseButton/CloseButton";

interface OwnProps {
    url: string;
    title: string;
    onClick: () => void;
}

const SocialButton = ({ url, title, onClick }: OwnProps) => {
    const handleLinkClick = (e) => {
        e.stopPropagation();
    };

    return (
        <div className={`${style.root} ${style[title]}`} onClick={ onClick }>
            { url && title && (
                <a
                    href={ url }
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${style.root} ${style[title]}`}
                    onClick={ handleLinkClick }
                ></a>
            )}
            <CloseButton />
        </div>
    );
};

export default SocialButton;
